import React from "react";
import { LogOut } from 'lucide-react';


/**
 * Removes the JSON Web Token from local storage.
 * ProtectedRoute or service pick up the changes and redirect user to the login page.
 */
export function LogoutButton() {

    const onClick = () => {
        //localStorage.removeItem('access_token');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('userCapability');
        sessionStorage.removeItem('otp');
        sessionStorage.removeItem('otp_date');
        sessionStorage.removeItem('lastTimeStamp');
        window.location.href = `${process.env.PUBLIC_URL || ""}/login`;
    }

    return (
        <button
            className="icon-btn"
            onClick={onClick}
            title="Logout"
        >
            <LogOut className="btn-icon" />
        </button>
    )
}
